import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class Folder extends DomainObject {
  name;
  createdAt;
  updatedAt;
  hasDocuments;
  hasSubfolders;
  parentId;
  companyDocuments;
  documents = [];
  subfolders = [];

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      createdAt: observable,
      updatedAt: observable,
      hasDocuments: observable,
      hasSubfolders: observable,
      parentId: observable,
      companyDocuments: observable,
      documents: observable,
      subfolders: observable
    });

    this.merge(other);
  }
}

export default Folder;
